module.exports = __webpack_public_path__ + "static/media/Nokia C3-00.3be7e6a3.png";